import React from 'react';
import ReviewCreator from './Creator';
import { Page, Button, Heading, TextContainer } from '@shopify/polaris';
import { useI18n } from '@hydra/common/customHooks';

import ScoreHistory from './ScoreHistory';
import Banner from '@hydra/routes/shopify/components/Review/Banner';
import AssistantInstaller from '../AssistantInstaller';
import CWVPageView from '../CWVPageView';
import InternalPageView from '../InternalPageView';

import { Grid } from '@material-ui/core';
import { Icon, Translate } from '@hydra/common/components';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(6)
  },
  titleContainer: {
    marginBottom: theme.spacing(2)
  },
  header: {
    padding: theme.spacing(4, 0)
  },
  woorankLogo: {
    height: 50,
    width: 180
  }
}));

type ReviewListParams = {
  host: string;
  apiKey: string;
  project: any;
};
export default function ReviewList ({
  host,
  apiKey,
  project
}: ReviewListParams) {
  const classes = useStyles();
  const { translate } = useI18n();

  return (
    <Page>
      <Grid
        container
        justify='space-between'
        alignItems='flex-end'
        spacing={4}
        className={classes.header}
      >
        <Grid item>
          <Icon
            type='woorank-by-bridgeline'
            viewBox='0 0 180 50'
            className={classes.woorankLogo}
          />
        </Grid>
        <Grid item>
          <Button url='https://www.woorank.com' external>
            {translate('shopify_woorank_cta_label')}
          </Button>
        </Grid>
      </Grid>

      <AssistantInstaller apiKey={apiKey} />

      <Banner url={project.url} key={apiKey} />

      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <TextContainer spacing='tight'>
            <Heading>
              <Translate content='shopify_score_graph_heading' />
            </Heading>
            <Translate content='shopify_score_graph_subheading' />
          </TextContainer>
        </div>
        <ScoreHistory url={project.url} apiKey={apiKey} />
      </div>

      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <TextContainer spacing='tight'>
            <Heading>
              <Translate content='shopify_internal_pages_heading' />
            </Heading>
          </TextContainer>
        </div>
        <ReviewCreator apiKey={apiKey} host={host} />
        <InternalPageView apiKey={apiKey} host={host} />
      </div>

      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <TextContainer spacing='tight'>
            <Heading>
              <Translate content='shopify_core_web_vitals_heading' />
            </Heading>
            <Translate content='shopify_core_web_vitals_subheading' with={{ value: 5 }} />
          </TextContainer>
        </div>
        <CWVPageView projectUrl={project.url} apiKey={apiKey} />
      </div>
    </Page>
  );
}
export { ReviewList };
